module.exports = __webpack_public_path__ + "img/wushuj.67caa395.png";